module.exports = __webpack_public_path__ + "static/media/FaktumTest-Bold.ed557f50.otf";